import { PdfAreaDontBreak, PdfH3, PdfTable } from 'pages/v2/compiler/PDF/Styles.styled';
import { Column, ColumnProps } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { useEpdLcaResultsAdditionalAcronyms } from 'services/api/queries';
import { LcaResultModel } from 'types/types';

import { LcaGridNote } from '../GridService';
import { DataTableStyledPdf } from './LcaResultsGridPdf';
import usePcrV2 from '../../hooks/usePcrV2';

type TProps = {
  epdVersionId: string;
  rows: LcaResultModel[] | undefined;
  columns: ColumnProps[];
  notes: LcaGridNote[];
  justificationForInclusion: string | undefined;
};
const LcaResultsGridExtendedPdf = ({ epdVersionId, rows, columns, notes, justificationForInclusion }: TProps) => {
  const acronymsQuery = useEpdLcaResultsAdditionalAcronyms(epdVersionId);
  const isPCRV2Selected = usePcrV2();
  const isThereAnythingToDisplay = (rows && rows.length > 0) || (isPCRV2Selected && justificationForInclusion);
  if (!isThereAnythingToDisplay) {
    return;
  }
  const acronyms = acronymsQuery.data?.acronyms;

  const footerGroup = (
    <ColumnGroup>
      <Row>
          <Column footer="Acronyms" colSpan={2} className="p-row-note" />
          <Column
            style={{ padding: '2px' }}
            footer={acronyms ?? ''}
            colSpan={columns.length}
            className="p-row-note"
          />
        </Row>
      {notes.map((x, i) => (
        <Row key={i}>
          <Column footer={x.note} colSpan={2} className="p-row-note" />
          <Column style={{ padding: '2px' }} footer={x.description} colSpan={columns.length} className="p-row-note" />
        </Row>
      ))}
    </ColumnGroup>
  );

  return (
    <PdfAreaDontBreak>
      <PdfH3>Additional voluntary environmental performance indicators</PdfH3>
      {rows && rows.length > 0 && (
        <DataTableStyledPdf
          value={rows}
          dataKey="id"
          tableStyle={{ minWidth: '49rem' }}
          showGridlines
          footerColumnGroup={footerGroup}
        >
          {columns.map((x) => (
            <Column key={x.field} {...x} />
          ))}
        </DataTableStyledPdf>
      )}
      {isPCRV2Selected && justificationForInclusion && (
        <PdfTable style={{ marginTop: '1rem' }}>
          <thead>
            <tr>
              <th style={{ width: '30%' }}></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Justification for inclusion</td>
              <td>{justificationForInclusion}</td>
            </tr>
          </tbody>
        </PdfTable>
      )}
    </PdfAreaDontBreak>
  );
};

export default LcaResultsGridExtendedPdf;
